/*
 * @description: 内容管理之素材管理
 * @author: Jsj
 * @Compile：2021-01-29 18：00
 * @update:jsj(2021-01-29 18：00)
 */
import axios from "@/utils/request";

/**
 * @memo 素材库分类 全部接口（findAll）
 */
export function category_all_path(data) {
  return axios({
    url: "/v1/admin/infImageCategory/findAll",
    method: "post",
    data
  });
}

/**
 * @memo 素材库分类 添加接口（save）
 * @param data
 * category_name  //类型：String  必有字段  备注：分类名称
 */
export function category_save_path(data) {
  return axios({
    url: "/v1/admin/infImageCategory/save",
    method: "post",
    data
  });
}

/**
 * @memo 素材库分类 修改接口（update）
 * @param id  //类型：String  必有字段  备注：编号
 * @param categoryName  //类型：String  可有字段  备注：分类名称
 */
export function category_update_path(data) {
  return axios({
    url: "v1/admin/infImageCategory/updateCategory",
    method: "post",
    data
  });
}

/**
 * @memo 素材库分类 删除接口（delete）
 * @param ids  //类型：String  必有字段  备注：编号
 */
export function category_delete_path(data) {
  return axios({
    url: "/v1/admin/infImageCategory/delete",
    method: "post",
    data
  });
}

/**
 * @memo 素材图片库 列表接口
 * @param currentPage  //类型：Number  可有字段  备注：当前页
 * @param numPerPage  //类型：Number  可有字段  备注：每页条数
 * @param category_id  //类型：String  可有字段  备注：分类id
 * @param img_name  //类型：String  必有字段  备注：图片名称
 */
export function image_list_path(data) {
  return axios({
    url: "/v1/admin/infImage/getList",
    method: "post",
    data
  });
}

/**
 * @memo 素材图片库 添加接口
 * @param category_id  //类型：String  必有字段  备注：图片分类id
 * @param img_name  //类型：String  必有字段  备注：图片名称
 * @param img_url  //类型：String  必有字段  备注：图片地址Url
 * @param img_type  //类型：String  必有字段  备注：文件内容类型
 * @param img_height  //类型：String  必有字段  备注：图片高 px
 * @param img_width  //类型：String  必有字段  备注：图片宽 px
 * @param img_size  //类型：String  必有字段  备注：图片文件大小 字节
 * @param memo  //类型：String  可有字段  备注：备注
 */
export function image_save_path(data) {
  return axios({
    url: "/v1/admin/infImage/saveBatch",
    method: "post",
    data
  });
}

/**
 * @memo 素材图片库 修改接口
 * @param id  //类型：String  必有字段  备注：编号
 * @param category_id  //类型：String  必有字段  备注：图片分类id
 * @param img_name  //类型：String  必有字段  备注：图片名称
 * @param img_url  //类型：String  必有字段  备注：图片地址Url
 * @param img_type  //类型：String  必有字段  备注：文件内容类型
 * @param img_height  //类型：String  必有字段  备注：图片高 px
 * @param img_width  //类型：String  必有字段  备注：图片宽 px
 * @param img_size  //类型：String  必有字段  备注：图片文件大小 字节
 * @param memo  //类型：String  可有字段  备注：备注
 */
export function image_update_path(data) {
  return axios({
    url: "/v1/admin/infImage/update",
    method: "post",
    data
  });
}

/**
 * @deprecated                      素材库图片---  修改
 * @param  id                       //类型：String  必有字段  备注：编号
 * @param  categoryID               //类型：String  可有字段  备注：分类Id
 */
export function image_update_category_path(data) {
  return axios({
    url: "/v1/admin/infImage/updateCategory",
    method: "post",
    data
  });
}

/**
 * @memo 素材图片库的删除
 * @param ids  //类型：String  必有字段  备注：删除，多个逗号分隔
 */
export function image_delete_path(data) {
  return axios({
    url: "/v1/admin/infImage/delete",
    method: "post",
    data
  });
}

/**
 * @memo 素材图片库 批量修改图片分类
 * @param ids  //类型：String  必有字段  备注：图片id，多个逗号分隔
 * @param category_id  //类型：String  必有字段  备注：图片分类id
 */
export function image_updateCategory_path(data) {
  return axios({
    url: "/v1/admin/infImage/updateCategory",
    method: "post",
    data
  })
}
